/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   ResidentQuotesModal actions
 */

import type { ResidentQuotesModal } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { CLEAR_DATA, RECEIVE_DATA } from '../constants/residentQuotesModal'

export const receiveResidentQuotesModalData = createAction<
  ResidentQuotesModal,
  typeof RECEIVE_DATA
>(RECEIVE_DATA)
export const clearResidentQuotesModalData = createAction<typeof CLEAR_DATA>(CLEAR_DATA)
